import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { modesRegistryQueryKey } from "../hooks/useModesRegistry";
import { useUser, useUserCredits } from "../hooks/useAuth";
import { apiClient } from "../utils/api";
import type { PartyGameCard } from "../types/api";
import { registryEntriesToPartyGames } from "./modePartyCards";

export function usePartyShellGames() {
  const { data: user } = useUser();
  const authed = Boolean(user);

  const registryQ = useQuery({
    queryKey: modesRegistryQueryKey,
    queryFn: () => apiClient.getModesRegistry(),
    staleTime: 10 * 60 * 1000,
  });

  const creditsQ = useUserCredits();

  const games: PartyGameCard[] = useMemo(
    () => registryEntriesToPartyGames(registryQ.data ?? [], authed),
    [registryQ.data, authed]
  );

  const credits = authed ? (creditsQ.data?.credit ?? null) : null;
  const isLoading = registryQ.isLoading || (authed && creditsQ.isLoading);
  const isError = registryQ.isError;

  const refetch = () => {
    void registryQ.refetch();
    if (authed) void creditsQ.refetch();
  };

  return {
    games,
    credits,
    authed,
    isLoading,
    isError,
    refetch,
    unlockedShellIds: games.filter((g) => g.access !== "paid").map((g) => g.id),
    grantShellIds: [] as string[],
  };
}

export function getFeaturedGame(list: PartyGameCard[]): PartyGameCard | undefined {
  return list.find((g) => g.featured) ?? list[2] ?? list[0];
}
